import { District, School, Sport, State } from 'types'

export const FEATURE_NAME = 'init'

export const DEFAULT_TITLE_FONT_SIZE = 34

export interface IState {
  title: string | null
  titleFontSize: number
  state: State | null
  district: District | null
  school: School | null
  sport: Sport | null
}
